import { Action } from "../actions/actions";
import { SkeletonActionTypes } from "../actions/actionTypes";

export interface SubAppConfig {
    services?: string[];
    title: string;
    icon: string;
    route?: string[];
    routes?: string[];
    permissions?: string[];
    listable: boolean;
    pathname?: string;
    default?: boolean;
    superuser?: boolean;
}

export function subAppsConfig(
    state: { [key: string]: SubAppConfig } = null,
    action: Action
): { [key: string]: SubAppConfig } {
    switch (action.type) {
        case SkeletonActionTypes.READ_SUBAPPS_CONFIG:
            return action.payload;

        default:
            return state;
    }
}
